import { ReportingControllerBaseConfig } from '../../../base';
import { HomeOptionController } from './homeOptionInterface';

export function createHomeOptionController(
    config: ReportingControllerBaseConfig
): HomeOptionController {
    const {
        kernel: {
            provider: { createFormController },
        },
    } = config;

    const formController = createFormController();
    return {
        useProps(context, props) {
            const form = formController.useProps(props.form);
            return {
                submit: {
                    label: 'Apply',
                    button: {
                        onClick: form.form.handleSubmit(
                            props.form.onSubmit,
                            props.form.onError
                        ),
                    },
                },
                fields: [
                    {
                        id: 'test-mode',
                        label: 'Test mode',
                        description: 'Deploy workspace infrastructure in test mode',
                        input: {
                            kind: 'switch',
                            switch: {
                                isChecked: props.values.test,
                                onChange(event) {
                                    form.form.setValue('test', event.target.checked);
                                },
                            },
                        },
                    },
                    {
                        id: 'version',
                        label: 'Version',
                        description:
                            'Prompt version tag to use for assistant and content generation',
                        input: {
                            kind: 'select',
                            options: [
                                { label: 'Active', value: 'active' },
                                { label: 'Latest', value: 'latest' },
                                { label: 'Preview', value: 'preview' },
                                { label: 'Develop', value: 'develop' },
                            ],
                            select: {
                                value: props.values.version,
                                onChange(event) {
                                    form.form.setValue(
                                        'version',
                                        event.target.value as
                                            | 'active'
                                            | 'latest'
                                            | 'preview'
                                            | 'develop'
                                    );
                                },
                            },
                        },
                    },
                ],
            };
        },
    };
}
